import { useEffect, useState } from "react";
import { getResponseStatus } from "@form/services/response";
import store, { actions, useTypedSelector } from "@/stores";
import useAccount from "./useAccount";
import { toast } from "react-toastify";

export default function useCampaignResponseStatus(id?: string) {
  const [loading, setLoading] = useState(false);
  const { isLogin } = useAccount();
  const [status, setStatus] = useState<any>(null);

  const form = useTypedSelector((state) => {
    return state.campaignVerify.form;
  });

  useEffect(() => {
    if (id && isLogin) {
      setLoading(true);
      getResponseStatus(id)
        .then((res) => {
          setStatus(res);
          if (!res) {
            return;
          }
          store.dispatch(
            actions.campaignVerify.changeForm({
              field: "id",
              value: res.id,
            })
          );
          if (res.email) {
            store.dispatch(
              actions.campaignVerify.changeForm({
                field: "email",
                value: res.email,
              })
            );
          }
          if (res.context.question) {
            store.dispatch(
              actions.campaignVerify.changeForm({
                field: "question",
                value: res.context.question,
              })
            );
          }
        })
        .catch((e) => {
          toast.error(e.message);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [id, isLogin]);

  return {
    form,
    loading,
    status,
    setStatus,
  };
}
